import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    position: relative;
    max-width: 480px;
    width: 100%;
    padding: 0;
    padding-bottom: 8px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme?.colors?.theme?.contentBg};
    cursor: pointer;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`;

export const ImageContainer = styled.div<{ $highlighted?: boolean }>`
    background: transparent;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    object-fit: cover;
    aspect-ratio: 16 / 9;
    margin: 0;
    line-height: 0;
    overflow: hidden;
    border-radius: 16px;


  /* Animated outline effect */
  animation: ${({ $highlighted }) => $highlighted ? "outlineAnimation 7s infinite linear":""};

  @keyframes outlineAnimation {
    0% {
      box-shadow: 0 0 0 1px ${({ theme }) => theme?.colors?.theme?.brandColor3}BF;
    }
    30% {
      box-shadow: 0 0 0 2px ${({ theme }) => theme?.colors?.theme?.brandColor3}; 
    }
    40% {
      box-shadow: 0 0 0 2px white; 
    }
    60% {
      box-shadow: 0 0 0 2px ${({ theme }) => theme?.colors?.theme?.brandColor3}; 
    }
    100% {
      box-shadow: 0 0 0 1px  ${({ theme }) => theme?.colors?.theme?.brandColor3}BF;
    }
  }
`;

export const CardImage = styled.img`
    width: 100%;
    background: transparent;
    box-shadow: -2px 2px 2px 0px rgba(10, 20, 26, 0.30);
    height: 100%;
    object-fit: cover;
    aspect-ratio: 16 / 9;
    // border: 2px solid ${({ theme }) => theme?.colors?.theme?.brandColor3};
    display: block;
    position: relative;
    z-index: 1;
    margin: 0;
    vertical-align: top;
`;

export const CardTitle = styled.h3`
    font-family: 'Red Hat Display', arial;
    font-size: 16px;
    font-weight: 600;
    line-height: 120%;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 4px 10px;
    margin: 0;
    box-sizing: border-box;
`; 